import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useNpsContext } from '../contexts/Nps.context';
import { NpsContactFormValues, npsContactFormSchema } from '../nps.schema';

const useNpsContactMeForm = () => {
  const { npsValues, handleAnswerJump, handleAnswerObservations, isSubmitting } = useNpsContext();

  const form = useForm<NpsContactFormValues>({
    resolver: zodResolver(npsContactFormSchema),
    defaultValues: {
      observation: npsValues.observation ?? '',
      contactMe: npsValues.contactMe ?? false,
    },
  });

  const handleValidSubmit = form.handleSubmit((data) => {
    handleAnswerObservations({
      contactMe: data.contactMe,
      observation: data.observation ?? '',
    });
  });

  return {
    control: form.control,
    register: form.register,
    isSubmitting,
    handleValidSubmit,
    handleAnswerJump,
  };
};

export default useNpsContactMeForm;
